export default [
  {
    title: 'Dashboard',
    group: 'apps',
    icon: 'fa-tachometer-alt',
    name: 'Dashboard',
    roleId: 1,
  },
  {
    title: 'Hashtag đơn hàng',
    group: 'apps',
    icon: 'fa-tag',
    name: 'hashtag-don-hang',
    roleId: 32
  },
  {
    title: 'Báo cáo',
    group: 'bao-cao',
    icon: 'fa-chart-line',
    name: 'Report',
    roleId: 4,
    hideRole: [512, 32],
    items: [
      {
        title: 'Công nợ',
        name: 'bao-cao-cong-no',
        component: 'bao-cao-cong-no',
        roleId: 8
      },
      {
        title: 'Doanh thu',
        name: 'bao-cao-doanh-thu',
        component: 'bao-cao-doanh-thu',
        roleId: 8
      },
      {
        title: 'Lợi nhuận đặt hàng',
        name: 'thong-ke-loi-nhuan-dat-hang',
        component: 'thong-ke-loi-nhuan-dat-hang',
        roleId: 1,
      },
      // { 
      //   title: 'Phí mua hàng',
      //   name: 'thong-ke-phi-mua-hang',
      //   component: 'thong-ke-phi-mua-hang',
      //   roleId: 2,
      // },
      // {
      //   title: 'Phí vận chuyển',
      //   name: 'thong-ke-phi-van-chuyen',
      //   component: 'thong-ke-phi-van-chuyen',
      //   roleId: 4
      // },
      {
        title: 'Chênh lệch tỷ giá',
        name: 'thong-ke-tien-te',
        component: 'thong-ke-tien-te',
        roleId: 8,
      },
      {
        title: 'Thống kê nạp tiền',
        name: 'bao-cao-nap-tien',
        component: 'bao-cao-nap-tien',
        roleId: 8
      },
      {
        title: 'Thống kê hoa hồng',
        name: 'thong-ke-hoa-hong-nhan-vien',
        component: 'thong-ke-hoa-hong-nhan-vien',
        roleId: 8
      },
      // {
      //   title: 'Doanh thu tổng',
      //   name: 'bao-cao-tong-hop',
      //   component: 'bao-cao-tong-hop',
      //   roleId: 8
      // },
      {
        title: 'Lô hàng',
        name: 'bao-cao-lo-hang',
        component: 'bao-cao-lo-hang',
        roleId: 8
      },
      {
        title: 'Xuất kho TQ',
        name: 'BigExport',
        component: 'BigExport',
        roleId: 16
      },
      {
        title: 'Lợi nhuận & hoa hồng',
        name: 'bao-cao-loi-nhuan',
        component: 'bao-cao-loi-nhuan',
        roleId: 8
      },
    ]
  },
  {
    name: 'QuoteList', 
    title: 'Báo giá', 
    group: 'apps',
    icon: 'fa-user',
    badge: true,
    roleId: 4096,
    children: [
      { name: 'QuoteDetail', title: 'Chi tiết báo giá', component: 'QuoteDetail' }
    ]
  },
  {
    title: 'Đơn hàng',
    group: 'don-hang',
    icon: 'fa-shopping-cart',
    name: 'OrderList',
    roleId: 32,
    badge: false,
    children: [
      { name: 'orderdetail', title: 'Chi tiết đơn hàng', component: 'OrderDetail' }
    ],
    items: [
      {
        title: 'Tất cả',
        component: 'OrderList',
        roleId: 1
      },
      {
        title: 'Chậm mua hàng',
        component: 'OrderList5',
        roleId: 1
      },
      {
        title: 'Chậm phát hàng',
        component: 'OrderList1',
        roleId: 1
      },
      {
        title: 'Chậm nhập kho TQ',
        component: 'OrderList2',
        roleId: 1
      },
      {
        title: 'Chậm nhập kho VN',
        component: 'OrderList3',
        roleId: 1
      },
      {
        title: 'Chậm trả khách',
        component: 'OrderList4',
        roleId: 1
      },
    ]
  },
  {
    title: 'Ký gửi',
    group: 'ky-gui',
    icon: 'fa-cart-plus',
    name: 'Deposit',
    roleId: 32,
    badge: false,
    children: [
      { name: 'DepositDetail', title: 'Chi tiết đơn hàng', component: 'DepositDetail' }
    ],
    items: [
      {
        title: 'Tất cả',
        component: 'Deposit',
        roleId: 1
      },
      {
        title: 'Chậm nhập kho TQ',
        component: 'DepositList2',
        roleId: 1
      },
      {
        title: 'Chậm nhập kho VN',
        component: 'DepositList3',
        roleId: 1
      },
      {
        title: 'Chậm trả khách',
        component: 'DepositList4',
        roleId: 1
      },
    ]
  },
  {
    title: 'Thanh toán hộ',
    group: 'apps',
    icon: 'fa-credit-card',
    name: 'PayServiceList',
    badge: true,
    roleId: 64,
    children: [
      { name: 'PayServiceDetail', title: 'Chi tiết thanh toán hộ', component: 'PayServiceDetail' }
    ]
  },
  {
    title: 'Kế toán',
    group: 'ke-toan',
    icon: 'fa-chart-line',
    name: 'Accountant',
    roleId: 128,
    items: [
      {
        title: 'Thanh toán',
        component: 'PayOrderList',
        roleId: 1
      },
      {
        title: 'Kiểm soát đơn hàng',
        component: 'AccountantOrder',
        roleId: 1,
        hideRole: [8],
      },
      {
        title: 'Tài chính',
        name: 'bao-cao-tai-chinh',
        component: 'bao-cao-tai-chinh',
        roleId: 16,
        hideRole: [8],
      },
      // {
      //   title: 'Luồng thu chi (¥)',
      //   component: 'AccountantCumulationList',
      //   roleId: 1
      // },
      // {
      //   title: 'Luồng thu chi (₫)',
      //   component: 'AccountantCumulationVNDList',
      //   roleId: 1
      // },
      {
        title: 'Shop hoàn tiền KN',
        component: 'TuiKuanList',
        roleId: 1,
        hideRole: [8],
      },
    ]
  },  
  {
    title: 'Khách hàng',
    group: 'apps',
    icon: 'fa-user',
    name: 'CustomerList',
    roleId: 8,
    hideRole: [4],
    children: [
      { name: 'CustomerDetail', title: 'Chi tiết khách hàng', component: 'CustomerDetail'  }
    ]
  },
  {
    title: 'Lịch sử giao dịch',
    group: 'apps',
    icon: 'fa-history',
    name: 'WalletHistory',
    roleId: 8,
    hideRole: [4],
  },
  {
    title: 'Nạp tiền',
    group: 'apps',
    icon: 'fa-wallet',
    name: 'RechargeNew',
    roleId: 16
  },
  {
    title: 'Rút tiền',
    group: 'apps',
    icon: 'fa-wallet',
    badge: true,
    name: 'WithdrawHistory',
    roleId: 8,
    hideRole: [4]
  },
  {
    title: 'Khiếu nại',
    group: 'apps',
    icon: 'fa-exclamation-circle',
    name: 'Complain',
    badge: true,
    roleId: 8,
    children: [
      { name: 'ComplainDetail', title: 'Chi tiết khiếu nại', component: 'ComplainDetail' }
    ]
  },
  {
    title: 'Mã vận đơn',
    group: 'apps',
    icon: 'fa-cubes',
    name: 'Transaction',
    roleId: 512
  },
  {
    title: 'Thu chi kho TQ',
    group: 'apps',
    icon: 'fa-info-circle',
    name: 'StoreReportList',
    roleId: 8192
  }, 
  {
    title: 'Xuất nhập kho TQ',
    group: 'apps',
    icon: 'fa-warehouse',
    name: 'StoreManager',
    roleId: 1024
  },
  // {
  //   title: 'Lô hàng - old',
  //   group: 'apps',
  //   icon: 'fa-truck',
  //   name: 'Consignment',
  //   roleId: 2048
  // }, 
  {
    title: 'Lô hàng',
    group: 'apps',
    icon: 'fa-box',
    name: 'BigPackage',
    roleId: 2048
  }, 
  {
    title: 'Hàng thất lạc',
    group: 'apps',
    icon: 'fa-question',
    name: 'NoName',
    roleId: 256
  },
  {
    title: 'Nhập kho VN',
    group: 'apps',
    icon: 'fa-store',
    name: 'StoreManagerVN',
    roleId: 256
  },
  {
    title: 'Tồn kho chưa giao',
    group: 'apps',
    icon: 'fa-stopwatch',
    name: 'ton-kho-chua-giao',
    hideRole: [64,512],
    roleId: 512
  },
  {
    title: 'Xuất kho VN',
    group: 'apps',
    badge: false,
    icon: 'fa-dolly-flatbed',
    name: 'Deliverable',
    roleId: 256
  },
  {
    title: 'Yêu cầu giao hàng', 
    group: 'thanh-toan',
    icon: 'fa-server',
    name: 'PaymentRequestList', 
    component: 'PaymentRequestList', 
    badge: true,
    roleId: 512,
    hideRole: [64,512],
    children: [
      { name: 'PaymentRequestDetail', title: 'Chi tiết yêu cầu giao hàng', component: 'PaymentRequestDetail' }
    ]
  },
  {
    title: 'Cài đặt',
    group: 'cai-dat',
    icon: 'fa-cogs',
    name: 'Setting',
    roleId: 2,
    items: [
      {
        name: 'Configuration', 
        title: 'Cấu hình chung', 
        component: 'Configuration'
      },
      {
        name: 'FlagList', 
        title: 'Hashtag', 
        component: 'FlagList', 
        children: [
          { name: 'FlagDetail', title: 'Chi tiết hashtag', component: 'FlagDetail' }
        ]
      },
      {
        title: 'Kho hàng TQ',
        name: 'ChinaStoreList',
        component: 'ChinaStoreList', 
        children: [
          { name: 'ChinaStoreDetail', title: 'Chi tiết kho TQ', component: 'ChinaStoreDetail' }
        ]
      },
      {
        title: 'Kho hàng VN',
        name: 'WarehouseList',
        component: 'WarehouseList', 
        children: [
          { name: 'WarehouseDetail', title: 'Chi tiết kho', component: 'WarehouseDetail' }
        ]
      },
      {
        title: 'Kho nhận',
        name: 'StoreExpList',
        component: 'StoreExpList', 
        children: [
          { name: 'StoreExpDetail', title: 'Chi tiết kho nhận', component: 'StoreExpDetail' }
        ]
      },
      {
        title: 'Nhân viên',
        name: 'StaffList',
        roleId: 1,
        component: 'StaffList', 
        children: [
          { name: 'StaffDetail', title: 'Chi tiết nhân viên', component: 'StaffDetail' }
        ]
      },
      {
        name: 'PartnerList', 
        title: 'Đối tác', 
        roleId: 1,
        component: 'PartnerList',
      },
      {
        name: 'FeeBuyList', 
        title: 'Phí mua hàng', 
        component: 'FeeBuyList', 
        children: [
          { name: 'FeeBuyDetail', title: 'Chi tiết phí mua hàng', component: 'FeeBuyDetail' }
        ]
      },
      {
        name: 'ProductTypeList', 
        title: 'Loại hàng', 
        component: 'ProductTypeList'
      },
      {
        name: 'FeeWeightOrgList', 
        title: 'Phí vận chuyển gốc', 
        component: 'FeeWeightOrgList'
      },
      {
        name: 'PricesList', 
        title: 'Bảng giá vận chuyển', 
        component: 'PricesList', 
        children: [
          { name: 'PricesDetail', title: 'Chi tiết bảng giá', component: 'PricesDetail' }
        ]
      },
      // {
      //   name: 'FeeWeightList', 
      //   title: 'Phí cân nặng', 
      //   component: 'FeeWeightList', 
      //   children: [
      //     { name: 'FeeWeightDetail', title: 'Chi tiết phí cân nặng', component: 'FeeWeightDetail' }
      //   ]
      // },
      // {
      //   name: 'FeeVolumeList', 
      //   title: 'Phí khối', 
      //   component: 'FeeVolumeList', 
      //   children: [
      //     { name: 'FeeVolumeDetail', title: 'Chi tiết phí khối', component: 'FeeVolumeDetail' }
      //   ]
      // },
      {
        name: 'FeeCheckList', 
        title: 'Phí kiểm đếm', 
        component: 'FeeCheckList', 
        children: [
          { name: 'FeeCheckDetail', title: 'Chi tiết phí kiểm đếm', component: 'FeeCheckDetail' }
        ]
      },
      {
        name: 'FeeGuaranteeList', 
        title: 'Phí bảo hiểm', 
        component: 'FeeGuaranteeList', 
        children: [
          { name: 'FeeGuaranteeDetail', title: 'Chi tiết phí bảo hiểm', component: 'FeeGuaranteeDetail' }
        ]
      },
      {
        name: 'FeeReinforceList', 
        title: 'Phí gia cố', 
        component: 'FeeReinforceList', 
        children: [
          { name: 'FeeReinforceDetail', title: 'Chi tiết phí gia cố', component: 'FeeReinforceDetail' }
        ]
      },
      { 
        name: 'CustomerLevel', 
        title: 'Khách hàng thân thiết', 
        component: 'CustomerLevel',
        children: [
          { name: 'CustomerLevelDetail', title: 'Chi tiết level', component: 'CustomerLevelDetail' }
        ]
      }
    ]
  },
  // {
  //   title: 'Nhập liệu',
  //   group: 'apps',
  //   icon: 'input',
  //   name: 'DataManager',
  // },  
];
